import { gql } from '@apollo/client';
import { VersionHistoryFields } from 'ants/query';

export const CmsStructureCreateHintQuery = gql`
query CmsStructureCreateHintQuery($name: String!) {
  cms_structure_create_hint(name: $name) {
    name
    similar_items {
      resource {
        account
        key
        hashkey: _hashkey
      }
      name {
        name
      }
    }
    key_suggestions
  }
}
`;

export const CmsStructureCreateMutation = gql`
mutation CmsStructureCreate(
  $name: CmsStructureNameInput!,
  $key: String,
) {
  cms_structure_create(
    name: $name,
    key: $key) {
      status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
    key_suggestions
  }
}
`;

export const StructureFields = `
resource {
  account
  key
  hashkey: _hashkey
}
name { name, store_type }
structure {
  name
  store_type
  active

  groups {
    fields {
      key
      store_type
      editor_type
      display_type

      required
      is_list
      searchable
      hide_on_edit

      related_field_path

      display_settings { html_tag, html_class }
      label

      primary_index

      title_index

      subtitle_index

      default_value

      structure { key, hashkey: _hashkey }
      resource_cls

      options { name, value }
      options_variable
    }
    key
    label
    key_prefix
    hide_on_edit
  }
}
`;

export const CmsStructureReadQuery = gql`
query CmsStructureReadQuery($resource: CmsStructureInput!, $withHistory: Boolean) {
  cms_structure_read(resource: $resource, with_history: $withHistory) {
    item {
      ${StructureFields} 
    }
    history {
      ${VersionHistoryFields}
    }
  }
}
`;

export const CmsStructureUpdateMutation = gql`
mutation CmsStructureUpdateMutation(
  $resource: CmsStructureInput!,
  $structure: CmsStructureStructureInput!,
  $version: RecordStage) {
  cms_structure_update(
    resource: $resource,
    structure: $structure,
    version: $version,
  ) {
    status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
  }
}
`;

export const CmsStructureDeleteMutation = gql`
mutation  CmsStructureDeleteMutation(
  $resource: CmsStructureInput!,
  $name: String!) {
  cms_structure_delete(resource: $resource, name: $name) {
    status {
      okay
      errors { msg, field_path, code}
      key
    }
  }
}
`;

export const CmsStructureSearchQuery = gql`
query CmsStructureSearchQuery($search: String!, $page: PagedRequestInput) {
  cms_structure_search(search: $search, page: $page) {
    items {
      resource {
        account
        key
        hashkey: _hashkey
      }
      name {
        name
        store_type
      }
    }
    page {
      next_page_key
      count
      prev_page_key
    }
  }
}
`;

export const CmsStructureMenuQuery = gql`
query CmsStructureMenuQuery {
  cms_structure_content_menu {
    items {
      resource {
        account
        key
        hashkey: _hashkey
      }
      name {
        name
        store_type
      }
    }
  }
}
`;

export const CmsStructureNameQuery = gql`
query CmsStructureNameQuery($resource: CmsStructureInput!) {
  cms_structure_name(resource: $resource) {
    name
  }
}
`;
